<template lang="pug">
  .height-100
    h3.title Gestión de excepciones de vacaciones
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.nueva-solicitud.position-relative(v-if="mostrarSolicitud", key="nueva_solicitud")
        nueva-solicitud-vacaciones(
          @close="mostrarSolicitud = false"
          :is-excepcion="true"
        )
      .box.nueva-solicitud.position-relative(v-if="mostrarCambioDias", key="cambio_dias_solicitud")
        cambio-dias-vacaciones(
          @close="mostrarCambioDias = false"
        )
</template>

<script>
import SolicitudVacacionesComponent from './Component_Solicitud_Vacaciones'
import CambioDiasVacacionesComponent from './Component_Cambio_Dias_Vacaciones'
export default {
  name: 'vacaciones',
  components: {
    'nueva-solicitud-vacaciones' : SolicitudVacacionesComponent,
    'cambio-dias-vacaciones'     : CambioDiasVacacionesComponent
  },
  data () {
    return {
      mostrarSolicitud: true,
      mostrarCambioDias: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Vacaciones_Excepcion.vue?3b3146d6